import React, { useState, useEffect } from 'react'
import { HubConnectionBuilder, IHttpConnectionOptions, HttpTransportType } from '@microsoft/signalr'
import { useNegotiate } from '../queries/tracking'
import { useUserMe } from '../queries/user'

type Tracking = {
  transport?: signalR.HttpTransportType | signalR.ITransport
}

type TrackingReturnType = {
  connection: signalR.HubConnection | null
}

const useTracking = ({
  transport = HttpTransportType.WebSockets
}: Tracking): TrackingReturnType => {
  const { data } = useNegotiate()
  const { data: userMe } = useUserMe()
  const [connection, setConnection] = useState<signalR.HubConnection | null>(null)

  useEffect(() => {
    if (connection) {
      if (data && data.accessToken && data.url) {
        connection.stop()

        const { accessToken, url } = data

        const newConnection = new HubConnectionBuilder()
          .withUrl(url, {
            headers: {
              'x-ms-client-principal-id': userMe?.email as string
            },
            accessTokenFactory: () => accessToken
          } as IHttpConnectionOptions)
          .withAutomaticReconnect()
          .build()
        setConnection(newConnection)
      }
    } else {
      if (data && data.accessToken && data.url) {
        const { accessToken, url } = data
        const options: IHttpConnectionOptions = {
          headers: {
            'x-ms-client-principal-id': userMe?.email as string
          },
          accessTokenFactory: () => accessToken
        }

        const newConnection = new HubConnectionBuilder()
          .withUrl(url, options)
          .withAutomaticReconnect()
          .build()
        setConnection(newConnection)
      }
    }
  }, [data])

  useEffect(
    () => () => {
      connection?.stop()
    },
    [connection]
  )

  return { connection }
}

export default useTracking
